import React from 'react'
import moment from 'moment'
import { Button, CircularProgress } from '@mui/material'
import { useSnackbar } from 'notistack'
import DownloadIcon from '@mui/icons-material/Download'
import { usePostExportCP58 } from '../../api/cp-58'

export const Export = ({ year }) => {
  const { mutateAsync: postExport, isLoading: isLoadingExport } = usePostExportCP58()
  const { enqueueSnackbar } = useSnackbar()

  const handleExport = async () => {
    try {
      // Get file
      const res = await postExport({ year })

      // Get timestamp
      const timestamp = moment().format('YYYYMMDDHHmmss')
      const url = URL.createObjectURL(res.data)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `CP58_${year}_${timestamp}.xlsx`)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      // Display error on popup
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to export data', {
        variant: 'error',
        autoHideDuration: 7000,
      })

      console.error(error)
    }
  }

  return (
    <Button
      startIcon={<DownloadIcon />}
      endIcon={isLoadingExport && <CircularProgress size='1.5rem' />}
      onClick={handleExport}
      disabled={isLoadingExport}
    >
      Export CP 58
    </Button>
  )
}
